<template>
    <div v-if="isreadshow">
        <!-- <my-search @search="searchHandler" v-model="pgData">
            <el-form-item slot="title"></el-form-item>
            <el-form-item slot="time"></el-form-item>
            <template slot="btn"> -->
                <el-button type="success" icon="el-icon-plus" size="small" style="margin-bottom:10px;" @click="beforeadd()" v-if="listData.model.ishbpsp!=='1'">添加</el-button>
                <el-button type="success" icon="el-icon-plus" size="small" style="margin-bottom:10px;" v-if="listData.model.ishbpsp==='1'" @click="add('1')">添加</el-button>
            <!-- </template>
        </my-search> -->
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="公告名称" prop="ggname" min-width="220"></el-table-column>
            <el-table-column label="公告编码" prop="ggcode" min-width="220"></el-table-column>
            <el-table-column label="发布日期" prop="ggfbtime" min-width="160"></el-table-column>
            <el-table-column label="公告性质" prop="ggxzname"></el-table-column>
            <el-table-column label="公告类型" prop="gglxname"></el-table-column>
            <el-table-column label="发布状态">
                <template slot-scope="scope">
                    <my-tag type="warning" v-if="scope.row.shbj==='0'" @click="showTips()">未提交</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='1'" @click="showTips()">已提交待内部审核</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='7'&&scope.row.tbzt==='1'&&listData.model.ishbpsp!=='1'" @click="showTips()">待平台审核</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='9'&&scope.row.tbzt==='1'" @click="showTips()">同步中</my-tag>
                    <el-button type="text" icon="el-icon-view" v-if="scope.row.shbj==='9'&&scope.row.tbzt==='2'" @click="getshdw(scope.row.ggcode)">查看状态</el-button>
                    <my-tag type="success" v-if="scope.row.shbj==='9'&&scope.row.tbzt==='9'" @click="showTips()">已发布</my-tag>
                    <el-button type="text" icon="el-icon-view" v-if="scope.row.shbj==='9'&&scope.row.tbzt==='9'&&listData.isrh" @click="getshdw(scope.row.ggcode)">查看审核结果</el-button>
                    <my-tag type="primary" v-if="scope.row.shbj==='6'&&scope.row.xtts==='1'">待交易中心审核</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='6'&&scope.row.xtts!=='1'">未推送交易中心</my-tag>
                    <div v-if="scope.row.shbj==='3'&&scope.row.tbzt==='3'&&listData.isrh">
                        <my-tag  type="danger">已退回</my-tag>
                        原因：{{scope.row.by2}}
                    </div>
                    <div v-if="scope.row.shbj==='3'&&!listData.isrh">
                        <div v-if="scope.row.by2===undefined||scope.row.by2===''||scope.row.by2===null">
                            <my-tag  type="danger">已退回</my-tag>
                            原因：无
                        </div>
                        <div v-else>
                            <my-tag  type="danger">已退回</my-tag>
                            原因：{{scope.row.by2}}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="交易中心" min-width="160">
                <template slot-scope="scope">
                    <jyzx-state v-if="scope.row.xtts" :data="scope.row"></jyzx-state>
                    <el-tag v-if="!scope.row.xtts">{{scope.row.jyzxname}}</el-tag>
                    <push-type 
                        v-if="$route.query.isXt==='1'"
                        :column="scope.row" 
                        :pushPage="'zbgg'" 
                        :primaryKey="scope.row.ggcode"
                        :procode="getQuery('procode')">
                    </push-type>

                </template>
            </el-table-column>
            <el-table-column label="项目经理下订单二维码" v-if="listData.isrh&&$route.query.isXt!=='1'" prop="ggcode" min-width="140">
                <template slot-scope="scope">
                    <a :href="'/FangAn/Zbgg/twovcodedown.do?ggcode='+scope.row.ggcode">点击下载</a>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="160">
                <template slot-scope="scope">
                    <my-btn v-if="scope.row.shbj==='1'||scope.row.shbj==='9'||scope.row.shbj==='6'||scope.row.shbj==='8'" type="detail" @click="detail(scope.row.ggcode,pgData.procode)">详情</my-btn>
                    <div v-if="scope.row.shbj==='1'||scope.row.shbj==='9'">
                        
                        <my-btn type="edit" @click="edit(scope.row.ggcode,'1')" v-if="scope.row.ggxzcode==='1'">发布变更公告</my-btn>
                        <!-- <el-button type="text" style="margin-left:0px;" icon="el-icon-refresh-left" @click="gettbmt(scope.row.ggcode,'tender')"
                        v-if="scope.row.fbbj==='1'&&scope.row.tbzt==='9'&&scope.row.shbj==='9'&&listData.plancode!==null&&listData.plancode!==''&&scope.row.ggxzcode==='1'">
                        查看政府采购同步状态</el-button>
                        <el-button type="text" style="margin-left:0px;" icon="el-icon-refresh-left" @click="gettbmt(scope.row.ggcode,'change')"
                        v-if="scope.row.fbbj==='1'&&scope.row.tbzt==='9'&&scope.row.shbj==='9'&&listData.plancode!==null&&listData.plancode!==''&&scope.row.ggxzcode==='2'">
                        查看政府采购同步状态</el-button> -->
                    </div>
                    <div v-if="scope.row.shbj!=='1'&&scope.row.shbj!=='9'&&scope.row.shbj!=='6'&&scope.row.shbj!=='8'">
                        <my-btn type="del" @click="del(scope.row.ggcode)">删除</my-btn>
                        <my-btn type="edit" @click="edit(scope.row.ggcode,'0')">修改</my-btn>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination v-if="$route.query.isXt!=='1'" ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/FangAn/Zbgg/get_list.json`"></my-pagination>
        <my-pagination v-if="$route.query.isXt==='1'" ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/FangAn/Zbgg/xingtai/get_list.json`"></my-pagination>
        <el-dialog  :visible.sync="adddialogVisible" title="公告录入方式" width="30%">
            <div style="height:300px;">
                <div class="gglrfs">
                    <div class="ggtj" @click="add('1')">
                        公告模板方式添加
                    </div>
                    <div class="ggtj" @click="add('2')">
                        自由录入方式添加
                    </div>
                </div>
                <my-tag type="danger">注：自由录入方式添加公告不能推送至招标投标公共服务平台</my-tag>
            </div>
        </el-dialog>
        <el-dialog  :visible.sync="shztdialogVisible" title="状态参考" width="30%">
            <div class="shzt">
                <el-timeline>
                    <el-timeline-item color="#409EFF">
                        已提交待内部审核——请在综合管理-招标公告审核处进行审核！
                    </el-timeline-item>
                    <el-timeline-item color="#409EFF">
                        同步中——已提交审核部门！
                    </el-timeline-item>
                    <el-timeline-item color="#409EFF">
                        备案部门待审核——已提交至备案部门，等待备案部门审核！
                    </el-timeline-item>
                    <el-timeline-item color="#409EFF">
                        已发布——审核已通过，公告已发布！
                    </el-timeline-item>
                    <el-timeline-item color="#409EFF">
                        已退回——审核未通过，公告被退回！
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-dialog>
        <el-dialog  :visible.sync="ztjgdialogVisible" title="查看状态/审核结果" width="50%">
            <div style="text-align:center;margin-bottom:20px;font-size:16px;" v-if="shdwform.ggstatus !== ''">
                推送状态：<my-tag type="primary" v-if="shdwform.ggstatus === '0'">已推送至公共服务平台，等待校验</my-tag>
                <my-tag type="success" v-if="shdwform.ggstatus === '1'">已推送至公共服务平台</my-tag>
                <my-tag type="primary" v-if="shdwform.ggstatus === '2'">公共服务平台正在校验：校验结果:{{ggyj}}</my-tag>
                <my-tag type="warning" v-if="shdwform.ggstatus === '-1'">尚未推送至公共服务平台</my-tag>
                <my-tag type="danger" v-if="shdwform.ggstatus === '3'">公告已被退回:{{shdwform.ggyj}}</my-tag>
                <my-tag type="primary" v-if="shdwform.ggstatus === '8'">待河北省交通招投标网人员审核</my-tag>
                <my-tag type="success" v-if="shdwform.ggstatus === '9'">公告已发布</my-tag>
            </div>
            <my-table :data="shdwlist">
                <el-table-column label="推送单位" prop="ggstatus">
                    <template slot-scope="scope">
                        {{scope.row.xtname}}:{{scope.row.dwname}}
                    </template>
                </el-table-column>
            </my-table>
            <my-table :data="shdwform.ggprocess.otherlist" v-if="shdwform.ggprocess.hasother&&shdwform.ggprocess.otherlist.length>0">
                <el-table-column label="其他审核流程" prop="ggstatus">
                    <template slot-scope="scope">
                        {{scope.row.auditdw}}:{{scope.row.auditstatus}}
                    </template>
                </el-table-column>
            </my-table>
            <my-table :data="shdwform.zjprocesslist" v-if="shdwform.ggprocess.haszj&&shdwform.ggprocess.zjlist.length>0">
                <el-table-column v-if="shdwform.ggprocess.haszj&&shdwform.ggprocess.zjlist.size<1" label="住建审核流程">
                    <template slot-scope="scope">
                        {{scope.row.node}}
                        <span v-if="(v,i) in scope.nodelist" :key="i">
                            {{v.auditdw}}--{{v.audituser}}--{{v.auditstatus}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="住建审核流程" v-else prop="ggstatus">
                    <template slot-scope="scope">
                        {{scope.row.node}}
                        <span v-if="(v,i) in scope.nodelist" :key="i">
                            {{v.auditdw}}--{{v.audituser}}--{{v.auditstatus}}
                        </span>
                    </template>
                </el-table-column>
            </my-table>
        </el-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page';
import JyzxState from '@views/bidding/components/jyzx-state'
import PushType from '@/components-sys/push-type'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
        PushType,JyzxState
    },
    data() {
        return{
            adddialogVisible:false,
            shztdialogVisible:false,
            ztjgdialogVisible:false,
            listData:{
                model:{
                    ishbpsp:''
                }
            },
            shdwform:{
                ggyj:'',
                ggstatus:'',
                ggprocess:{},
                ggyj:'',
                zjprocesslist:[]
            },
            shdwlist:[],
            pgData:{
                procode:'',
                sortname:'addtime',
                txtKey:'',
                proKey:''
            },
            isreadshow:true,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //查看所有发布状态
        showTips:function(){
            this.shztdialogVisible=true;
        },
        //查看状态
        getshdw:function(ggcode){
            this.ztjgdialogVisible=true;
            var that = this;
            this.$get(`${this.getGetters('bidUrl')}/Zbdl/AuditZbgg/getshdw.json`,{ggcode:ggcode},(data,res)=>{
                if(res.result){
                    if(data.shdwlist!=='[]'){
                        that.shdwlist=data.shdwlist;
                    }
                }else{
                    ShowMsg(res.msg,'error')
                }              
            })
            this.$get(`${this.getGetters('bidUrl')}/Zbdl/AuditZbgg/getTbzt.json`,{ggcode:ggcode},(data,res)=>{
                if(res.result){
                    if(data!==null){
                        that.shdwform.ggstatus = data.t.bj;
                        that.shdwform.ggprocess = data.t.shdw;
                        that.shdwform.ggyj = data.t.yj;
                        that.shdwform.zjprocesslist =  data.t.zjprocesslist;
                    }
                }else{
                    ShowMsg(res.msg,'error');
                }
            })
            
        },
        //查看政府采购同步状态
        gettbmt:function(ggcode,type){
            var that = this;
            that.$get(`${this.getGetters('bidUrl')}/Zbdl/AuditZbgg/gettbmt.json`,{ggcode:ggcode,type:type}, (data, res) => {
                if(res.code==='v'){
                    if(data.status==='0'){
                        ShowMsg('待推送');
                    }else if(data.status==='1'){
                        ShowMsg('已推送待发布');
                    }else if(data.status==='9'){
                        ShowMsg('已发布','success');
                    }
                }else{
                    ShowMsg(data.msg,'error');
                }
            }); 
        },
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //删除
        del:function(ggcode){
            var that=this; 
            if(this.$route.query.isXt==='1'){
                this.$post(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/del`,{id:ggcode}, (data, res) => {
                    ShowMsg(res.msg, 'success');
                    that.reload();
                }); 
            }else{
                this.$post(`${this.getGetters('bidUrl')}/FangAn/Zbgg/del`,{id:ggcode}, (data, res) => {
                    ShowMsg(res.msg, 'success');
                    that.reload();
                });
            }      
        },
        //详情
        detail:function(ggcode,procode){
            if(this.$route.query.isXt!=='1'){
                window.location.href="/FangAn/Zbgg/detail?id="+ggcode+'&procode='+procode;
            }else{
                window.location.href="/FangAn/Zbgg/xingtai/detail?id="+ggcode+'&procode='+procode;
            }            
        },
        //添加前选择框
        beforeadd:function(){
            this.adddialogVisible=true;
        },
        //添加
        add:function(code){         
            if(code==='1'){
                window.location.href="/gg/ggmbPage?procode="+this.$route.query.procode;
            }else{
                if(this.$route.query.isXt!=='1'){
                    window.location.href="/FangAn/Zbgg/edit.do?procode="+this.$route.query.procode;
                }else{
                    window.location.href="/FangAn/Zbgg/xingtai/edit.do?procode="+this.$route.query.procode;
                }                  
            }
        },
        //修改
        edit:function(ggcode,code){
            if(code==='0'){
                if(this.$route.query.isXt!=='1'){
                    window.location.href="/FangAn/Zbgg/edit?id="+ggcode+'&procode='+this.pgData.procode;
                }else{
                    window.location.href="/FangAn/Zbgg/xingtai/edit.do?id="+ggcode+'&procode='+this.pgData.procode;
                }       
            }else{
                if(this.$route.query.isXt!=='1'){
                    window.location.href="/FangAn/Zbgg/edit?yggcode="+ggcode+'&procode='+this.pgData.procode;
                }else{
                    window.location.href="/FangAn/Zbgg/xingtai/edit.do?yggcode="+ggcode+'&procode='+this.pgData.procode;
                }  
            } 
        }
    },
    created() {
        var that = this;
        if(this.$route.query.procode!=undefined){
            this.pgData.procode=this.$route.query.procode;
        }
        if(this.$route.query.isXt==='1'){
            this.$get(`${this.getGetters('bidUrl')}/FangAn/Zbgg/xingtai/list.json`,this.pgData,(data,res)=>{
                if(res.code==='v'){
                    that.listData=data;
                }
            })
        }else{
            this.$get(`${this.getGetters('bidUrl')}/FangAn/Zbgg/list.json`,this.pgData,(data,res)=>{
                if(res.code==='v'){
                    that.listData=data;
                }
            })
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
.gglrfs{width:100%;display: flex;justify-content: space-between;margin-bottom:20px;}
.gglrfs .ggtj{width: 40%;height:40px;line-height:40px;padding-left:10px;border:1px solid #157FCC;border-radius:4px;cursor:pointer;color:#157FCC;}
.gglrfs .ggtj:hover{background: #157FCC;border:1px solid #157FCC;color:#fff;}
// .shzt{width: 100%;height:400px;line-height: 50px;}
</style>
